import React, {useState, useEffect} from 'react';
import SMCModal from '../../../components/core/SMCModal';
import {useTranslation} from 'react-i18next';
import ExportDomainSMP from './ExportDomainSMP';

function ExportDomainSMPModal({
    isOpen = false,
    onRequestClose
}) {
    const { t } = useTranslation();

    const [editorStep, setEditorStep] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');
    

    // Reset all values on open
    useEffect(() => {
        if (isOpen) {
            setEditorStep(0);
            setErrorMessage('');              
        }
    }, [isOpen]);

    const onFinish = () => { }

    let EditorBody = () => null;

    switch (editorStep) {
        case 0:
            EditorBody = ExportDomainSMP;
            break;
        default:
            onRequestClose();
            break;
    }

    return (
        <SMCModal
            isOpen={isOpen}
            width={710}
            height={280}
            title={t('SMC_SYSOPS_EXPWIZ_TITLE')}
            onRequestClose={onRequestClose}
            hasError={!!errorMessage}
            errorMessage={errorMessage}
        >
            <EditorBody
                onCancel={onRequestClose}
                onNext={() => setEditorStep(step => step+1)}
                onBack={() => setEditorStep(step => step-1)}
                onFinish={onFinish}
            />
        </SMCModal>

    );
}

export default ExportDomainSMPModal;